module.exports = __webpack_public_path__ + "static/img/winnipeg3.077852a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/winnipeg3.jpg
// module id = 152
// module chunks = 9